import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import useTableFijo from "../useTableFijo";
import CatalogoOrdenPago3 from "../../catalogos/catalogoOrdenPago3";
import { Input } from "../../ui/inputs/Input";
import {
  DangerButton,
  PrimaryButton,
  SuccessButton,
} from "../../ui/buttons/Button";

export const ModalAprobarOrden = (props) => {
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° Documento",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Concepto",
      textAlign: "center",
    },
  ];
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState("hidden");
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [mostrar5, setMostrar5] = useState(false);
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFecha = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtCodigo = useRef();
  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTableFijo(
    records,
    headCells,
    filterFn,
    220
  );

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar las Solicitudes",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let datost = [];
      let validad = [];
      if (operacion === 1) {
        datos.push({
          nid: 0,
          fec: txtFecha.current.value,
          obser: txtObservacion.current.value.trim(),
          tip: parseInt(ticomp),
          depart: parseInt(depart),
          idefi: idefiscal,
          devol: tip,
          aprob: true,
        });
        for (let e = 0; e < data.length; e++) {
          datost.push({
            nid: data[e].idaprobacionesdetalle,
            motiv: data[e].motivo,
            idorden: data[e].idordenpago,
            conce: data[e].concepto,
            idapro: 0,
            tip: parseInt(data[e].tipo),
          });
        }
        for (let i = 0; i < data.length; i++) {
          validad.push({
            idordencs: data[i].idordenpago,
            idefis: idefiscal,
            val: data[i].val,
            tipocom: parseInt(ticomp),
            tipo: tip,
            validaparam: data[i].validaparam,
          });
        }
      }
      setBody({
        operacion: operacion,
        nid: txtCodigo.current.value !== "" ? txtCodigo.current.value : 0,
        fec: txtFecha.current.value,
        obser: txtObservacion.current.value,
        tip: props.tip,
        depart: 2,
        idefi: idefiscal,
        devol: "1",
        aprob: true,
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Aprobar estos Documentos?.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const ActualizarDetalle = (id) => {
    let endpoint = `${op.conexion}/api/administracion/detalleaprobacionact`;
    setActivate(true);
    let body = {
      idapro: id,
      tipocom: props.tip,
      ordenes: records,
      idefi: idefiscal,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Orden de Pago Aprobada Correctamente",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/aprobacionesact`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          ActualizarDetalle(response.data[0].aprobaciones_act);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();
    setValues(item);
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setRecords([]);
    setVisible("hidden");
    setActivate(false);
    setValida([]);
    setDepart(null);
    setData([]);
    setTicomp(null);
    setBody(null);
  };
  const opciones = (ope, index) => (event) => {
    event.preventDefault();
    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
    } else {
      setRecords(records.filter((it) => it.idordenpago !== values.idordenpago));
    }
  };
  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
  };
  const agregarOrdenPago = (values) => {
    setMostrar5(false);
    let array = records;
    if (records.length === 0) {
      //array.push(values);
      setRecords(values);
    } else {
      let sigue = true;
      for (let i = 0; i < values.length; i++) {
        for (let x = 0; x < array.length; x++) {
          if (values[i].idordenpago === array[x].idordenpago) {
            /*setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La Ordn de Pago " + values[x].idordenpago + " ya fue agregada.",
              icono: "informacion",
            });*/
            sigue = false;
            break;
          } else {
            sigue = true;  
          }
        }
        if (sigue) {
          array = [...array, values[i]];
        }  

      }
      setRecords(array);
    }
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setRecords(props.detalle);
          txtCodigo.current.value = props.aprobacion.idaprobaciones;
          txtFecha.current.value = moment.utc(props.aprobacion.fecha).format(
            "YYYY-MM-DD"
          );
          txtObservacion.current.value = props.aprobacion.observaciones;
          if (props.aprobacion.aprobado) {
            setVisible(true);
          }
        } else {
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 fw-bold m-0">
          Administración - Enviar Orden de Pago a Tesoreria
        </h3>
        <button className="btn btn-sm bg-light" onClick={cancelar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div >
          <input type="hidden" ref={txtNp} />
          <fieldset className="col-12 border-azul rounded m-0 mb-2 p-2 d-flex flex-wrap">
            <legend className="float-none m-0 w-auto fw-bold">Datos</legend>
            <div className="col-3 col-lg-2 m-0 p-0 pr-2">
              <Input
                label="Código:"
                name="observacion"
                disabled={true}
                id="inputDireccion"
                ref={txtCodigo}
              />
            </div>
            <div className="col-4 col-lg-2 m-0 ml-lg-auto p-0">
              <Input
                label="Fecha:"
                type="date"
                disabled
                defaultValue={moment.utc(fechaSistema).format("DD/MM/YYYY")}
                id="inputDireccion"
                ref={txtFecha}
              />
            </div>
            <div className="col-12 p-0 m-0 mt-2">
              <Input
                label="Observación:"
                name="observacion"
                onChange={onChange}
                disabled={
                  operacion === 4 || operacion === 2 ? true : deshabilitado
                }
                id="inputDireccion"
                ref={txtObservacion}
              />
            </div>
          </fieldset>
          <fieldset className="col-12 border-azul rounded m-0 p-2">
            <div className="col-12 m-0 p-0 d-flex">
              <div className="col-11 m-0 px-0 mb-1">
                <TblContainer
                  container={{ height: 250, width: "100%", overflow: "auto" }}
                >
                  <TblHead />
                  <tbody>
                    {records &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <tr
                          key={item + item.idordenpago}
                          className="table-bordered"
                          disabled={
                            operacion === 4 || operacion === 2
                              ? true
                              : deshabilitado
                          }
                          style={{
                            padding: "0",
                            cursor: "pointer",
                            background:
                              values.idordenpago === item.idordenpago
                                ? "lightskyblue"
                                : "white",
                          }}
                          onClick={seleccionarFila(item)}
                        >
                          <td
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "50px",
                            }}
                          >
                            {item.numordenpago}
                          </td>
                          <td
                            style={{
                              fontSize: "10px",
                              textAlign: "left",
                              width: "350px",
                            }}
                          >
                            {item.concepto}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
              </div>
              <div className="col-1 m-0 p-0 pl-2 d-flex flex-column justify-content-center alig-items-center gap-2">
                <PrimaryButton
                  icon="fa-plus m-0"
                  onClick={opciones(1, "")}
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                ></PrimaryButton>
                <DangerButton
                  icon="fa-trash m-0"
                  onClick={opciones(0, "")}
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                ></DangerButton>
              </div>
            </div>
            <div
              className="col-12 mx-auto"
              style={{ display: visible === "hidden" ? "none" : "flex" }}
            >
              <h3 className="text-success text-center fw-bold">
                EL DOCUMENTO YA FUÉ ENVIADO A TESORERIA
              </h3>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton onClick={onChangeValidar}>Aceptar</SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <CatalogoOrdenPago3
        show={mostrar5}
        onHideCancela={() => {
          setMostrar5(false);
        }}
        onHideAceptaCatalogo={agregarOrdenPago}
        ubicacion={42}
      />
    </Modal>
  );
};
